import { Component, OnInit } from "@angular/core";
import { CompanylinkedService } from "../../services/companylinked.service";
import { Icon } from "../../models/card-icon";
import swal from "sweetalert2";
import { Methods } from "../../shared/methods";
import { UserService } from '../../services/user.service';

@Component({
  selector: "app-yearlyweightgoal",
  templateUrl: "./yearlyweightgoal.component.html",
  styleUrls: ["./yearlyweightgoal.component.css"],
})
export class YearlyweightgoalComponent implements OnInit {
  public mtds: Methods = new Methods();
  iconEditMail: Icon = {
    icon: "schedule",
    title: "Yearly Weight Goal",
  };

  // public mtds: Methods = new Methods();
  public identity;
  public token;
  public saving;
  public loading: boolean = false;
  public yearlyWeightGoal;
  public idCompany: any = 0;
  public textDone: any = '';
 
  constructor(
    private _companylinkedService: CompanylinkedService,
    private _userService: UserService,
  ) {
    this.token = JSON.parse(localStorage.getItem('token'));

    this.identity = this._userService.getIdentity();
    console.log("this.identity => ", this.identity);
    this.idCompany = this.identity.companyId;
  }

  saveCompany() {
    let json;
    json = {
      value: this.yearlyWeightGoal,
      type:'yearlyWeightGoal'
    };
    this.loading = true;
    this._companylinkedService.updatebyparam(this.token, json, this.idCompany).subscribe(
      (response) => {
        if (response.status == "success") {
          this.textDone = "Registry Updated";
          this.done();
         
        }
        this.loading = false;
        return response;
      },
      (error) => {
        this.loading = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
    // this.getProbation();
  }
  showSwal() {
    swal.fire({
      title: "Are you sure?",
      text: "You will not be able to revert this!",
    
      showCancelButton: true,
     

      customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
      confirmButtonText: "Yes, delete it!",
      buttonsStyling: false,
    });
  }
  deleted() {
    swal.fire({
      title: "Deleted!",
      text: "The year has been deleted",
   
    customClass:{
    confirmButton: 'btn btn-success'
            },
      buttonsStyling: false,
    });
  }
  done() {
    swal.fire({
      title: "Done",
      text: this.textDone,
   
    customClass:{
    confirmButton: 'btn btn-success'
            },
      buttonsStyling: false,
    });
  }
  removePto(id) {
    swal.fire({
      title: "Are you sure?",
      text: "You will not be able to revert this!",
    
      showCancelButton: true,
    

      customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
      confirmButtonText: "Yes, delete it!",
      buttonsStyling: false,
    }).then(
      function (result) {
        if (result.value) {
          this._configpto.delete(id).subscribe(
            (response) => {
              if (response.status === "success") {
                this.deleted();
              }
              this.getPto();
              console.log(response);
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
            }
          );
          this.getPto();
        }
      }.bind(this)
    );
  }

  getCompany(){
      this._companylinkedService.getCompany(this.token, this.idCompany).subscribe(
        (response) => {
          console.log(response);
          this.yearlyWeightGoal = response.data.yearlyWeightGoal;
          },
        (error) => {
          console.log(<any>error);
        }
      );
    }

  ngOnInit() {
  this.getCompany();
  }
}
